module.exports = __webpack_public_path__ + "img/pen.003df32c.jpg";